import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProfessionalAuth } from "../store/authProfessionalStore";

type Props = {
  children: ReactNode;
};

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <p className="text-gray-600">Chargement...</p>
  </div>
);

export default function RequireAuthProfessional({ children }: Props) {
  const { isAuthenticated, isLoading } = useProfessionalAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;

  if (!isAuthenticated) {
    const redirectTo = `/professionnel/connexion?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
